import Vue from 'vue'
import { searchReportListForAdmin } from '@/api/report'
import { searchStudyListForAdmin } from '@/api/report'
import { searchMeasurementListForAdmin } from '@/api/report'
import { sendCrsDetailEmail } from '@/api/report'
import { sendExamDetailEmail } from '@/api/report'
import { studymentListDetail } from '@/api/report'
import { measurementListDetail } from '@/api/report'
import { ACCESS_TOKEN } from '@/store/mutation-types'

const report = {
  state: {
    loading: false
  },

  mutations: {},

  actions: {

    SearchReportListForAdmin({ commit }, record) {
      return new Promise((resolve, reject) => {
        searchReportListForAdmin(record).then(response => {
          console.log(response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SearchStudyListForAdmin({ commit }, record) {
      return new Promise((resolve, reject) => {
        searchStudyListForAdmin(record).then(response => {
          console.log(response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SearchMeasurementListForAdmin({ commit }, record) {
      return new Promise((resolve, reject) => {
        searchMeasurementListForAdmin(record).then(response => {
          console.log(response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    StudymentListDetail({ commit }, record) {
      return new Promise((resolve, reject) => {
        studymentListDetail(record).then(response => {
          console.log(response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    MeasurementListDetail({ commit }, record) {
      return new Promise((resolve, reject) => {
        measurementListDetail(record).then(response => {
          console.log(response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendCrsDetailEmail({ commit }, record) {
      return new Promise((resolve, reject) => {
        sendCrsDetailEmail(record).then(response => {
          console.log(response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SendExamDetailEmail({ commit }, record) {
      return new Promise((resolve, reject) => {
        sendExamDetailEmail(record).then(response => {
          console.log(response)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default report
